import React, { memo, useMemo } from 'react';
import { useLocale } from '@react-aria/i18n';
import { date } from '../../utils';
import { useGridState, SelectorCell, Selector } from './selector';
import styles from './styles.module.css';
import { useCalendarContext } from './contexts';
const COLUMNS = 1;
function useMonthsSelectState({ value, onSelect, isRange }) {
    return useGridState({
        minValue: 1,
        // всего 6 ренжей январь-февраль (1) ... ноябрь-декабрь (6)
        maxValue: isRange ? 6 : 12,
        columns: COLUMNS,
        value,
        onSelect,
    });
}
const MonthCell = memo(function MonthCell({ value, isRange }) {
    const { locale } = useLocale();
    const format = new date.DateFormatter(locale, { month: 'long' });
    const { state } = useCalendarContext();
    const visibleYear = state.visibleRange.start.year;
    const startValue = isRange
        ? // левый месяц ренжа
            new Date(Date.UTC(visibleYear, value * 2 - 1 - 1, 1, 0, 0, 0))
        : new Date(Date.UTC(visibleYear, value - 1, 1, 0, 0, 0));
    const endValue = isRange
        ? // правый месяц ренжа
            new Date(Date.UTC(visibleYear, value * 2 - 1, 1, 0, 0, 0))
        : startValue;
    const disabled = useMemo(() => {
        var _a, _b;
        const start = date.stringToDate(startValue.toISOString());
        const end = date.stringToDate(endValue.toISOString());
        const minValue = (_a = state.minValue) === null || _a === void 0 ? void 0 : _a.copy().set({ day: 1 });
        const maxValue = (_b = state.maxValue) === null || _b === void 0 ? void 0 : _b.copy().set({ day: 1 });
        if (minValue && minValue.compare(end) > 0)
            return true;
        if (maxValue && maxValue.compare(start) < 0)
            return true;
    }, [state.minValue, state.maxValue, startValue, endValue]);
    const startValueFormatted = format.format(startValue);
    const endValueFormatted = format.format(endValue);
    return (React.createElement(SelectorCell, { className: styles.monthButton, value: value, disabled: disabled }, startValueFormatted === endValueFormatted ? (startValueFormatted) : (React.createElement(React.Fragment, null,
        React.createElement("span", null, startValueFormatted),
        React.createElement("span", null, " \u2013 "),
        React.createElement("span", null, endValueFormatted)))));
});
export function MonthsSelect(props) {
    const state = useMonthsSelectState(props);
    return (React.createElement(Selector, { ...props, columns: COLUMNS, state: state, renderValue: value => React.createElement(MonthCell, { value: value, isRange: props.isRange }) }));
}
